import { PageHead } from "@generalapplications/html-render/react";
import { ContactFormSection } from "@/app/pages/contact/components/ContactFormSection";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { contactPage } from "@/content/contact";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { PageArticle } from "@generalapplications/ui";

export function ContactPage() {
  const head = pageHead({
    path: routes.contact,
    title: contactPage.seoTitle,
    description: contactPage.seoDescription,
    imagePath: contactPage.image,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <PageHero
        headline={contactPage.headline}
        copy={contactPage.heroCopy}
        image={contactPage.image}
      />
      <ContactFormSection />
    </PageArticle>
  );
}
